import { render, staticRenderFns } from "./main2.vue?vue&type=template&id=d54aae18&scoped=true&"
import script from "./main2.vue?vue&type=script&lang=js&"
export * from "./main2.vue?vue&type=script&lang=js&"
import style0 from "./main2.vue?vue&type=style&index=0&id=d54aae18&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d54aae18",
  null
  
)

export default component.exports